module.exports = __webpack_public_path__ + "static/media/Spot_accessibility.e38ad6fd.pdf";